export default {"src":"/_next/static/media/wave-promo-general-bg.e9a6c680.svg","height":1382,"width":6830,"blurWidth":0,"blurHeight":0};